module.exports = __webpack_public_path__ + "assets/img/monkeytalks-logo-narrow.529e223a7bb02b1fb906eea64268a5c5.svg";